import { render, staticRenderFns } from "./regimentList.vue?vue&type=template&id=0e9ad909&scoped=true&"
import script from "./regimentList.vue?vue&type=script&lang=js&"
export * from "./regimentList.vue?vue&type=script&lang=js&"
import style0 from "./regimentList.vue?vue&type=style&index=0&id=0e9ad909&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9ad909",
  null
  
)

export default component.exports